export default {
  authorized: (state) => !!state.token,
  authstatus: (state) => state.authStatus,
  user: (state) => {
    return state.user;
  },
  users: (state, getters) => {
    return state.users;
  },
  kotaProvinsi: (state, getters) => {
    return state.kotaProvinsi;
  },
};
